import { UCCViewParams, UCCViewTypes } from '..'
import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'

export class UCCViewProvider extends AbstractProvider {
  urlPath = 'ucc_view_api'

  public view<T>(action: UCCViewTypes, params: Partial<UCCViewParams>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
